export const USERS = [
    {name: 'User 1', colour: 'pink', initials: 'U1', id: '7b4f9858-36b3-4755-997a-5becd20e21bc'},
    {name: 'User 2', colour: 'Aqua', initials: 'U2', id: '044ff405-b82b-4e25-867b-e9236d965b58'},
    {name: 'User 3', colour: 'Chocolate', initials: 'U3', id: '8c4d1cfa-98f9-4d9d-87f3-1413b55befe6'},
]

// colour: the stroke / accent colour. fillColour: the ~94%-opacity tint fill
// (lets the uploaded diagram show through faintly, per the redesign).
// textColour: the darker, readable colour used for the oval's own text.
export const STATES = {
    NOT_DONE: {colour: '#E5484D', fillColour: 'rgba(253,236,236,0.94)', textColour: '#B42318', text: 'Not Done', value: 'NOT_DONE'},
    IN_PROGRESS: {colour: '#F5A524', fillColour: 'rgba(254,244,222,0.94)', textColour: '#A15C07', text: 'In Progress', value: 'IN_PROGRESS'},
    DONE: {colour: '#30A46C', fillColour: 'rgba(228,245,235,0.94)', textColour: '#18794E', text: 'Done', value: 'DONE'},
    // Not part of the redesigned 3-status toolbar (see product decision in
    // the Sep 2026 app redesign session) - kept in the model, hidden from
    // the new UI, so any existing data/API/Jira mapping using it is unaffected.
    OPTIONAL: {colour: '#3346E0', fillColour: 'rgba(241,242,254,0.94)', textColour: '#3346E0', text: 'Optional', value: 'OPTIONAL'},
}
